<section class="banner">
  <div class="media">
    <img src="assets/icons/truck-moving-green.svg" alt="order track blanc">
  </div>

  <div class="wrapper">
    <p>Your driver is on his way</p>
    <a [routerLink]="gpsTranckingRoute" class="btn-banner">Follow my driver</a>
  </div>
</section>